import withBarberFilterHandlers from '../../filters/withBarberFilterHandlers';
import { getActiveBarbersFilterIds, getAllBarbersFilter } from '../../../main/reports/selectors';
import {
  addBarberFilterReport,
  removeBarberFilterReport,
  showAllBarberFiltersReport,
  hideAllBarberFiltersReport,
} from '../../../main/reports/actions';

const mapDispatchToProps = {
  add: addBarberFilterReport,
  remove: removeBarberFilterReport,
  showAll: showAllBarberFiltersReport,
  hideAll: hideAllBarberFiltersReport,
};

export default withBarberFilterHandlers(getActiveBarbersFilterIds, getAllBarbersFilter, mapDispatchToProps);
